import { ReactNode } from "react";
import style from "../cim-sub-menu.module.css";
import classNames from "classnames";

export default function WidgetMenuItem({
  image,
  title,
  subtitle,
  onClick,
}: {
  image: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  onClick?: () => void;
}) {
  return (
    <button
      className={classNames(style.card, style.buttonReset)}
      onClick={onClick}
      style={{
        width: "160px",
        height: "135px",
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: "400",
        textAlign: "start",

        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        className={style.thumbnail}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "7px",
          border: "1px solid rgb(235,237,243)",
          backgroundColor: "#f8f9fc",
          width: "159px",
          height: "100px",
        }}
      >
        {image}
      </div>
      <div
        style={{
          color: "#1E1E1E",
          fontSize: "12px",
          marginTop: "8px",
        }}
      >
        {title}
      </div>
      <div
        style={{
          color: "#AFB3BF",
          fontSize: "10px",
        }}
      >
        {subtitle}
      </div>
    </button>
  );
}
